import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { Alert, Spinner, takeTokenFromHash } from '@shripos/ui';
import { api, queryClient } from '../../lib/api.js';
import { useSession } from '../../stores/session.js';
import { AuthShell } from './AuthPages.jsx';

/**
 * Landing page for the admin portal's "View as client" link: swaps the one-time ticket in the
 * URL fragment for a read-only owner session, then opens the app.
 */
export function ImpersonatePage() {
  const navigate = useNavigate();
  const [token] = useState(() => takeTokenFromHash());
  const [error, setError] = useState(token ? null : 'This link is incomplete. Start again from the admin portal.');
  const started = useRef(false);

  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;
    api
      .post('/auth/impersonate', { token })
      .then((res) => {
        queryClient.clear();
        useSession.getState().signedIn(res.me);
        navigate('/', { replace: true });
      })
      .catch((err) => setError(err.message));
  }, [token, navigate]);

  return (
    <AuthShell title="Support view" subtitle="Opening the client's app read-only…">
      {error ? <Alert tone="danger">{error}</Alert> : <Spinner />}
    </AuthShell>
  );
}
